import { type CountryCode, getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js'

export const composeInternationalPhone = (country: CountryCode, nationalInput: string) => {
  const digits = nationalInput.replace(/\D/g, '')
  if (!digits) return ''

  const parsed = parsePhoneNumberFromString(digits, country)
  if (parsed?.number) return parsed.number

  const national = digits.replace(/^0+/, '')
  return national ? `+${getCountryCallingCode(country)}${national}` : ''
}

/** Prefer E.164; otherwise compose local digits with the default country (NG → +234…). */
export const toInternationalPhone = (raw: string, defaultCountry: CountryCode = 'NG') => {
  const trimmed = raw.trim()
  if (!trimmed) return ''
  if (trimmed.startsWith('+')) {
    return parsePhoneNumberFromString(trimmed)?.number || composeInternationalPhone(defaultCountry, trimmed)
  }
  return composeInternationalPhone(defaultCountry, trimmed)
}

export const isValidInternationalPhone = (value?: string | null) => {
  if (!value) return false
  return Boolean(parsePhoneNumberFromString(value)?.isValid())
}

export const splitInternationalPhone = (value: string, fallbackCountry: CountryCode = 'NG') => {
  const parsed = parsePhoneNumberFromString(value)
  if (parsed?.country && parsed.nationalNumber) {
    return { country: parsed.country, national: parsed.nationalNumber, e164: parsed.number }
  }

  if (!value.startsWith('+')) {
    const national = value.replace(/\D/g, '')
    return {
      country: fallbackCountry,
      e164: composeInternationalPhone(fallbackCountry, national),
      national
    }
  }

  return { country: fallbackCountry, e164: value, national: '' }
}
